import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IGameModeChangedData} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {Background} from "@nolimitcity/slot-game/bin/core/background/Background";
import {HorribleHeroesGameMode} from "../HorribleHeroesGameMode";
import {HorribleHeroesGameAssets} from "../HorribleHeroesGameAssets";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {HorribleHeroesEvents} from "../events/HorribleHeroesEvents";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite} from "gsap";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {HorribleHeroesGameModuleConfig} from "../HorribleHeroesGameModuleConfig";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {SoundManager} from "../resource/sound/SoundManager";

export class HorribleHeroesBackground extends Background {
    private readonly cloudYs: number[] = [-200, -100];
    private readonly cloudStartPos: number[] = [0, 1280];
    private readonly cloudEndPos: number[] = [682, 860];
    private readonly fwOffset: number = 280;
    private _backgroundSprite_main: PIXI.Sprite;
    private _clouds: PIXI.Sprite[];
    private _cloudPanningTimeLine: TimelineLite;
    private _fsLeftHandle: PIXI.Sprite;
    private _chainFS: PIXI.Sprite;
    private bgForeground: PIXI.Sprite;
    private lightiniing: TimelineSprite;
    private _deviceOrientation: Orientation;

    private smokeLT: TimelineSprite;
    private _backgroundAnimationFire: PIXI.spine.Spine;
    private _backgroundAnimationFireSparks: PIXI.spine.Spine;
    private frontChains: PIXI.spine.Spine;
    private rightChains: PIXI.spine.Spine;
    private backChains: PIXI.spine.Spine;
    private _tl: TimelineLite;
    private isPlayingParticles: boolean;
    private _bgContainer: PIXI.Container;
    private isPlayingMobile: boolean = false;
    private iscurrentModeFS: boolean = false;
    private _reelChainsPortrait: PIXI.spine.Spine;
    private _reelChainsPortrait2: PIXI.spine.Spine;
    private _prevRandomLightningCount: number = -1;

    // #247
    public exitFS(): void {
        this.smokeLT.hide();
        this.smokeLT.stopLoop();
    }

    public playChainAnimationForMobile(): void {
        this._reelChainsPortrait.updateTransform();
        this._reelChainsPortrait.visible = true;
        this._reelChainsPortrait.state.clearTracks();
        this._reelChainsPortrait.state.setAnimation(0, "animation", true);

        this._reelChainsPortrait2.updateTransform();
        this._reelChainsPortrait2.visible = true;
        this._reelChainsPortrait2.state.clearTracks();
        this._reelChainsPortrait2.state.setAnimation(0, "animation", true);
    }

    public stopChainAnimationForMobile(): void {
        this._reelChainsPortrait.visible = false;
        this._reelChainsPortrait.state.clearTracks();
        this._reelChainsPortrait2.visible = false;
        this._reelChainsPortrait2.state.clearTracks();
    }

    public playFireAnimationLevel(level: string): void {
        this._backgroundAnimationFire.updateTransform();
        this._backgroundAnimationFire.visible = true;
        this._backgroundAnimationFire.state.clearTracks();
        this._backgroundAnimationFire.state.setAnimation(0, "bg_fireIdleLevel" + level, true);
    }

    /**
     * @inheritDoc
     */
    protected initAnimations(): void {
        super.initAnimations && super.initAnimations();
        this._bgContainer = new PIXI.Container();
        this._bgContainer.name = "_bgContainer";
        this._backgroundSprite_main = new PIXI.Sprite(GameResources.getTextures("mainBackground")[0]);
        this._backgroundSprite_main.name = "backgroundSprite_main";
        this._backgroundSprite_main.position.set(-480, -480);
        this._bgContainer.addChild(this._backgroundSprite_main);
        this.addChild(this._bgContainer);
        this.lightiniing = this.createTimelineSprite("lightning", [-100, 250], PIXI.BLEND_MODES.ADD);
        this._clouds = this.createClouds();
        this._chainFS = this.createSprite("chainFS", [213, -183]);
        this._reelChainsPortrait2 = this.createSpineAnimation("Bottom_Portrait", [1350, 1051]);
        this._reelChainsPortrait = this.createSpineAnimation("Single_Chain", [-407, -84]);

        this._chainFS.visible = false;
        this._fsLeftHandle = this.createSprite("leftMetalAsset", [-86, 360]);
        this.smokeLT = this.createTimelineSprite("Smoke_LT", [-102, 321], PIXI.BLEND_MODES.NORMAL, 60);
        this._backgroundAnimationFire = this.createSpineAnimation("bg_idle_fire", [350, 330]);
        this.backChains = this.createSpineAnimation("Back_Chians", [341, 393]);
        this.frontChains = this.createSpineAnimation("Front_Chains", [299, 738]);
        this.rightChains = this.createSpineAnimation("Rt_Top_Chain", [351, 727]);
        this.rightChains.scale.set(1.5);
        this._backgroundAnimationFireSparks = this.createSpineAnimation("fsintroTransitionFirespark", [360, 360]);
        this._backgroundAnimationFireSparks.updateTransform();
        this._backgroundAnimationFireSparks.visible = true;
        this._backgroundAnimationFireSparks.state.setAnimation(0, "transitionFirespark", true);
        this.bgForeground = this.createSprite("bgForeground", [400, 605]);

        this._bgContainer.addChild(this._backgroundAnimationFireSparks);
        this._bgContainer.addChild(this._backgroundAnimationFire);
        this._bgContainer.addChild(this.bgForeground);
        this.playCloudAnimation();
        //507
        //512
    }

    protected onChangeBackground(data: IGameModeChangedData): boolean {
        if (data.newMode === HorribleHeroesGameMode.FREESPIN_LOW || data.newMode === HorribleHeroesGameMode.FREESPIN_MID) {
            this._backgroundSprite_main.texture = GameResources.getTextures(HorribleHeroesGameAssets.MAIN_GAME_BACKGROUND_FS)[0];
            this._layer.addChildAt(this, 0);
            this.addChildAt(this._bgContainer, 0);
            this.showFsAssets();
            this.iscurrentModeFS = true;
            EventHandler.dispatchEvent(new GameEvent(HorribleHeroesEvents.CHANGE_LAYERS));
        } else {
            this.isPlayingParticles = false;
            this._backgroundSprite_main.texture = GameResources.getTextures(HorribleHeroesGameAssets.MAIN_GAME_BACKGROUND)[0];
            this.hideFsAssets();
            this.iscurrentModeFS = false;
        }
        if (data.newMode === HorribleHeroesGameMode.FREESPIN_PICK) {
            this.isPlayingParticles = true;
            EventHandler.dispatchEvent(new GameEvent(HorribleHeroesEvents.PLAY_FS_FIRE_PARTICLES));
            this.addChild(this._bgContainer);
            this._layer.addChild(this);
        }

        return true;
    }

    protected onResize(resizeData: IResizeData): void {
        this._deviceOrientation = resizeData.orientation;
        if (resizeData.orientation === Orientation.LANDSCAPE) {
            this._backgroundAnimationFireSparks.visible = false;
            this._backgroundAnimationFireSparks.state.clearTracks();
            this.isPlayingMobile = false;
            if (this.iscurrentModeFS) {
                this.hideFSMobileAssets();
                this.showFSDesktopAssets();
            }
        } else {
            this.isPlayingMobile = true;
            if (this.iscurrentModeFS) {
                this.showFSMobileAssets();
                this.hideFSDesktopAssets()
            } else {
                this._backgroundAnimationFireSparks.updateTransform();
                this._backgroundAnimationFireSparks.visible = true;
                this._backgroundAnimationFireSparks.state.setAnimation(0, "transitionFirespark", true);
            }
        }
    }

    private createClouds(): PIXI.Sprite[] {
        const clouds: PIXI.Sprite[] = ArrayHelper.initArrayWithValues(2, (i: number) => {
            const cloud: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("cloud_" + 0)[0]);
            cloud.anchor.set(0.5, 0.5);
            cloud.position.set(0, this.cloudYs[i]);
            this._bgContainer.addChild(cloud);
            cloud.name = "cloud";
            return cloud;
        });
        return clouds;
    }

    private createSpineAnimation(resourceName: string, pos: number[]): PIXI.spine.Spine {
        const sprite = new PIXI.spine.Spine(GameResources.getSpineAsset(resourceName));
        sprite.pivot.set(0.5, 0.5);
        sprite.position.set(pos[0], pos[1]);
        sprite.visible = false;
        sprite.name = resourceName;
        sprite.state.setEmptyAnimation(0, 0);
        this.addChild(sprite);
        return sprite;
    }

    private createTimelineSprite(resourceName: string, pos: number[], blendMode?: PIXI.BLEND_MODES, fps: number = 30): TimelineSprite {
        const sprite = new TimelineSprite(GameResources.getTextures(resourceName), fps);
        sprite.anchor.set(0.5, 0.5);
        sprite.name = resourceName;
        sprite.position.set(pos[0], pos[1]);
        sprite.hide();
        if (blendMode) {
            sprite.blendMode = PIXI.BLEND_MODES.ADD;
        }
        this.addChild(sprite);
        return sprite;
    }

    private createSprite(textureName: string, pos: number[]): PIXI.Sprite {
        const sprite: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(textureName)[0]);
        sprite.anchor.set(0.5, 0.5);
        sprite.name = textureName;
        sprite.position.set(pos[0], pos[1]);
        this.addChild(sprite);
        return sprite;
    }

    private showFSMobileAssets(): void {
        this.playChainAnimationForMobile();

        this.hideChains();

        HorribleHeroesGameModuleConfig.reelBackGroundView._fsBar.visible = true;
        this._chainFS.visible = true;
    }

    private hideFSMobileAssets(): void {
        HorribleHeroesGameModuleConfig.reelBackGroundView._fsBar.visible = false;
        this._chainFS.visible = false;
        this.stopChainAnimationForMobile();
    }

    private playThunderEffect(): void {
        this._tl = new TimelineLite({
            onComplete: () => {
                this._tl.restart();
            }
        });
        let delay = MathHelper.randomIntInRange(4, 5);
        this._tl.add(() => {
            this.showLightEffect();
        }, delay);
    }

    private showLightEffect(): void {
        let sides = ["left", "right"],
            scaleX = [-1, 1],
            randomSides = sides[Math.floor(Math.random() * sides.length)],
            randomScaleX = scaleX[Math.floor(Math.random() * scaleX.length)],
            randomPositions: any = {
                "portrait": {
                    "left": [134, -62],
                    "right": [534, -62]
                },
                "landscape": {
                    "left": [-100, 250],
                    "right": [830, 250]
                }
            },
            thunderPositions: number[] = randomPositions[this._deviceOrientation][randomSides];

        this.lightiniing.position.set(thunderPositions[0], thunderPositions[1]);
        this.lightiniing.scale.x = randomScaleX;

        this.lightiniing.getAnimation();
        this.lightiniing.show();

        // #459
        let randomLightingCount: number = MathHelper.randomIntInRange(1, 3);
        while (randomLightingCount === this._prevRandomLightningCount) {
            randomLightingCount = MathHelper.randomIntInRange(1, 3);
        }
        this._prevRandomLightningCount = randomLightingCount;
        SoundManager.playLightning(randomLightingCount);
    }

    private showFsAssets(): void {
        //common for fs desktop and  mobile
        this.hideClouds();
        this.playThunderEffect();
        if (!this.isPlayingParticles) {
            EventHandler.dispatchEvent(new GameEvent(HorribleHeroesEvents.PLAY_FS_FIRE_PARTICLES));
        }

        if (this.isPlayingMobile) {
            this.showFSMobileAssets();
        } else {
            //fs desktop
            this.showFSDesktopAssets();
            this.hideFSMobileAssets();
        }
        //hide bg assets
        this.bgForeground.visible = false;
        this.stopIdleAnimation();
        this._backgroundAnimationFireSparks.visible = false;
        this._backgroundAnimationFireSparks.state.clearTracks();
    }

    private showFSDesktopAssets(): void {
        this._fsLeftHandle.visible = true;
        this.smokeLT.show();
        this.smokeLT.playLoop();
        HorribleHeroesGameModuleConfig.reelBackGroundView.playChainAnimation("1");

        this.backChains.updateTransform();
        this.backChains.visible = true;
        this.backChains.state.setAnimation(0, "animation", true);

        this.frontChains.updateTransform();
        this.frontChains.visible = true;
        this.frontChains.state.setAnimation(0, "animation", true);

        this.rightChains.updateTransform();
        this.rightChains.visible = true;
        this.rightChains.state.setAnimation(0, "animation", true);
    }

    private hideFSDesktopAssets(): void {
        this._fsLeftHandle.visible = false;
        this.smokeLT.hide();
        this.smokeLT.stopLoop();
        HorribleHeroesGameModuleConfig.reelBackGroundView.playChainAnimation("1");

        this.hideChains();
    }

    private hideFsAssets(): void {
        this.lightiniing.stopLoop();
        this.lightiniing.hide();
        if (this._tl) {
            this._tl.clear();
            this._tl.kill();
        }
        this.hideFSDesktopAssets();
        this.hideFSMobileAssets();
        EventHandler.dispatchEvent(new GameEvent(HorribleHeroesEvents.STOP_FS_FIRE_PARTICLES));

        //show bg  assets
        this.bgForeground.visible = true;
        HorribleHeroesGameModuleConfig.reelBackGroundView.playChainAnimation("1");
        if (this.isPlayingMobile) {
            this._backgroundAnimationFireSparks.updateTransform();
            this._backgroundAnimationFireSparks.visible = true;
            this._backgroundAnimationFireSparks.state.setAnimation(0, "transitionFirespark", true);
        }
        this.playFireAnimationLevel("1");
        this.playCloudAnimation();
    }

    private stopIdleAnimation(): void {
        this._backgroundAnimationFire.visible = false;
        this._backgroundAnimationFire.state.clearTracks();
    }

    private playCloudAnimation(): void {
        this._cloudPanningTimeLine = new TimelineLite();
        if (this._clouds && this._clouds.length > 0) {
            this._clouds.forEach((cloud: PIXI.Sprite, index: number) => {
                cloud.position.x = this.cloudStartPos[index];
                cloud.visible = true;
                this._cloudPanningTimeLine.add(this.getCloudAnimation(cloud, index), index);
            });
        }
    }

    private hideClouds(): void {
        this._cloudPanningTimeLine.pause();
        this._cloudPanningTimeLine.kill();
        if (this._clouds && this._clouds.length > 0) {
            this._clouds.forEach((cloud: PIXI.Sprite, index: number) => {
                cloud.position.x = this.cloudStartPos[index];
                cloud.visible = false;
            });
        }
    }

    private getCloudAnimation(cloud: PIXI.Sprite, index: number): TimelineLite {
        const offset: number = this.fwOffset;
        const timeLine: TimelineLite = new TimelineLite({
            onComplete: () => {
                cloud.position.x = this.cloudStartPos[index] - offset;
                this.getCloudAnimation(cloud, index);
                timeLine.pause();
                timeLine.kill();
            }
        });
        timeLine.to(cloud, 60, {x: this.cloudEndPos[index] - offset});
        timeLine.to(cloud, 50, {x: this.cloudStartPos[index] - offset});
        return timeLine;
    }

    private hideChains(): void {
        this.backChains.visible = false;
        this.backChains.state.clearTracks();
        this.frontChains.visible = false;
        this.frontChains.state.clearTracks();
        this.rightChains.visible = false;
        this.rightChains.state.clearTracks();
    }
}


